import React, { useEffect, useRef } from "react"
import { AiOutlineClose } from "react-icons/ai"
import { HiOutlineShoppingBag } from "react-icons/hi"
import { useNavigate } from "react-router-dom"
import useCartContext from "../context/CartContext"
import useGlobalContext from "../context/GlobalContext"
import useProducts from "../context/ProductsContext"
import CartItem from "./CartItem"
import Loading from "./Loading"

const Cart = () => {
  const navigate = useNavigate()
  const containerRef = useRef(null)
  const cartOutside = useRef(null)
  const { cartItems } = useCartContext()
  const { openCart, setOpenCart } = useGlobalContext()
  const { products, isLoading } = useProducts()

  useEffect(() => {
    const ref = containerRef.current
    const checkClickBoundary = (e) => {
      if (
        (ref == null || ref?.contains(e.target)) &&
        !cartOutside.current.contains(e.target)
      )
        return
      setOpenCart(false)
    }

    ref?.addEventListener("click", checkClickBoundary)

    return () => {
      ref?.removeEventListener("click", checkClickBoundary)
    }
  }, [setOpenCart])

  const goToCheckout = (e) => {
    e.preventDefault()
    setOpenCart(false)
    navigate("/checkout")
  }

  return (
    <div
      ref={containerRef}
      className={`cart-container ${openCart ? "show" : ""}`}
    >
      <div className="cart-container-c" ref={cartOutside}></div>
      <div className="cart-content">
        <div className="cart-header">
          <h4>
            <HiOutlineShoppingBag />
            Cart summary
          </h4>
          <button onClick={() => setOpenCart(false)} className="close">
            close <AiOutlineClose />
          </button>
        </div>
        <div className="cart-body">
          {isLoading ? (
            <Loading />
          ) : cartItems.length <= 0 ? (
            <div className="cart-body-empty">
              <p>Your Cart is Empty!</p>
              <button
                onClick={() => setOpenCart(false)}
                className="btn-cta danger"
              >
                Back to shop
              </button>
            </div>
          ) : (
            <div className="cart-body-items">
              {cartItems.map((item) => (
                <CartItem key={item.id} item={item} />
              ))}
            </div>
          )}
        </div>
        {!isLoading && cartItems.length > 0 ? (
          <div className="cart-footer">
            <p>Shipping and taxes will be calculated at checkout.</p>
            <div className="cart-footer-total">
              <p className="cart-total-price">Total</p>
              <p className="cart-total-price">
                $
                {cartItems.reduce((total, item) => {
                  return (
                    (item.quantity *
                      products?.find((p) => p.id === item.id).price || 0) +
                    total
                  )
                }, 0)}
              </p>
            </div>
            <button
              onClick={goToCheckout}
              disabled={cartItems.length <= 0}
              className="btn-cta danger checkout"
            >
              Chceckout
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default Cart
